import { render, staticRenderFns } from "./ProductsSideBar.vue?vue&type=template&id=f2b6a3aa&scoped=true"
import script from "./ProductsSideBar.vue?vue&type=script&lang=js"
export * from "./ProductsSideBar.vue?vue&type=script&lang=js"
import style0 from "./ProductsSideBar.vue?vue&type=style&index=0&id=f2b6a3aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b6a3aa",
  null
  
)

export default component.exports